export const SITE_TITLE = "NordNative OÜ"
export const COLOR_MAIN = "043F63"
export const COLOR_MAIN_01 = "B8DBD9"
export const COLOR_MAIN_02 = "DBF2DC"
export const COLOR_MAIN_03 = "51778B"
export const COLOR_MAIN_04 = "29666E"
export const COLOR_MAIN_05 = "6E8658"

export const SOCIAL_LINK_FACEBOOK = "https://facebook.com/nordnative"
export const SOCIAL_LINK_INSTAGRAM = "https://instagram.com/nordnative4"
export const SOCIAL_LINK_LINKEDIN = "https://www.linkedin.com/company/nordnative/?viewAsMember=true"
export const SOCIAL_LINK_TIKTOK = "https://www.tiktok.com/@nordnative"
export const SOCIAL_LINK_TWITTER = "https://twitter.com/nordnative"
export const SOCIAL_LINK_YOUTUBE = "https://youtube.com/nordnative"


export const NEWSLETTER_LIST = "nordnative.com"

//local
export const CRM_API_BASE_URL = "http://localhost:9960"
export const CRM_API_TOKEN = "MjAyNTI3LTY1ODczNi0wMDAwMTp2UDNpVzMwNUw1YXk5VU1uemMzODlGWjllcVp6MkE="

//prod
// export const CRM_API_BASE_URL = "https://crmapi01.bunnycrm.com"
// export const CRM_API_TOKEN = "MjAyNDgzLTEwNDQzNjUyLTAwMDAzOktia2F1akROVVV3Z3JsNDhUa0xIN0c2QjBQenBEVw=="

export const CRM_API_CONTACTUS_API_URL = CRM_API_BASE_URL + "/v1/support_ticket"
export const CRM_API_NEWSLEETER_SUBS_URL = CRM_API_BASE_URL + "/v1/newsletter_subscriber/sub"
export const CRM_API_NEWSLEETER_UNSUB_URL = CRM_API_BASE_URL + "/v1/newsletter_subscriber/unsub"


export const ABOUT_PAGE_ABOUT_CEO = ``

export const ABOUT_PAGE_ABOUT_US = `NordNative OÜ is a SaaS company focused on automation, sales, and marketing solutions.
We help businesses streamline lead capture, outreach, follow-ups, and reporting with modern, secure, and reliable platforms.`
export const ABOUT_PAGE_OUR_VISION = `<section>
      <h2>Our Vision</h2>
      <p>
        To simplify sales and marketing operations with automation that is fast to adopt and easy to scale.
      </p>
    </section>`
export const ABOUT_PAGE_OUR_MISSION = `<section>
      <h2>Why Choose Us?</h2>
      <ul>
        <li>Purpose-built SaaS for sales and marketing teams</li>
        <li>Automation-first workflows to reduce manual work</li>
        <li>Clear dashboards, reporting, and measurable outcomes</li>
        <li>Secure, reliable, and scalable infrastructure</li>
      </ul>
    </section>`
export const ABOUT_PAGE_CORE_VALUES = ``
export const ABOUT_PAGE_PRODUCTS_AND_SOLUTION = ``

export const ABOUT_PAGE_ABOUT_COMMITMENT_TO_INNOVATION = ``
export const ABOUT_PAGE_ABOUT_WHY_CHOOSE_US = ``
export const ABOUT_PAGE_CONTACT_US_PARA1 = ``
export const ABOUT_PAGE_CONTACT_US_PARA2 = ``

export const CONTACT_US_ADDRESS_MAIN = 'Kesklinna Linnaosa, Ahtri tn 12, 10151 Tallinn Estonia'
export const CONTACT_US_ADDRESS_MAIN_LINE1 = 'Kesklinna Linnaosa, Ahtri tn 12,'
export const CONTACT_US_ADDRESS_MAIN_LINE2 = '10151 Tallinn Estonia'

export const CONTACT_US_EMAIL_MAIN = 'info@nordnative.com'
export const SUPPORT_EMAIL = 'support@nordnative.com'
export const PRIVACY_EMAIL = 'privacy@nordnative.com'
export const SALES_EMAIL = 'sales@nordnative.com'
export const MARKETING_EMAIL = 'marketing@nordnative.com'
export const HR_EMAIL_MAIN = 'hr@nordnative.com'
export const OFFICE_EMAIL_MAIN = 'office@nordnative.com'
export const JOBS_APPLICATION_EMAIL = 'careers@nordnative.com'
export const CONTACT_US_PHONE_MAIN = '+49 15563 002941'
export const CONTACT_US_WHATSAPP_MAIN = '4915563002941'
export const CONTACT_US_WEB_MAIN = 'https://nordnative.com'

export const HOME_PAGE_HEADLINE01 = 'Empowering Businesses with Cutting-Edge Software as a Service Solutions'
export const HOME_PAGE_HEADLINE02 = 'We specialize in delivering cutting-edge sales and marketing solutions to empower businesses in the digital era'
export const HOME_PAGE_HEADLINE03 = 'Automate lead capture, outreach, and reporting with BunnyCRM — NordNative\'s SaaS platform built for sales and marketing teams. Contact us today to see how automation can help your business grow.'

export const PRODUCT_DESCRIPTION_03 = `BunnyCRM Sales takes the manual work out of the pipeline — from the moment a lead arrives to the moment a deal closes.`
export const PRODUCT_DESCRIPTION_04 = `BunnyCRM Marketing runs campaigns end-to-end, so they execute consistently at scale instead of depending on manual sends.`
export const PRODUCT_DESCRIPTION_05 = `BunnyCRM Support is the helpdesk built into BunnyCRM — customer inquiries, tickets, and self-service in one place, on the same contact records sales and marketing already use.`
export const PRODUCT_DESCRIPTION_06 = `BunnyCRM Notes is a personal-usage product inside BunnyCRM — a place to maintain your own notes, personal or business-related, alongside the rest of your workspace.`
export const PRODUCT_DESCRIPTION_07 = `BunnyCRM Action Items turns follow-ups into tracked tasks, so commitments made in a note, ticket, or deal don't get lost.`
export const PRODUCT_DESCRIPTION_08 = `BunnyCRM Drive is BunnyCRM's file storage product — you can use it to manage your files online for personal use as well as for your business.`

export const OFFER_DESCRIPTION_01 = ``
export const OFFER_DESCRIPTION_02 = ``
export const OFFER_DESCRIPTION_03 = ``
export const OFFER_DETAIL_01 = ``
export const OFFER_DETAIL_02 = ``
export const OFFER_DETAIL_03 = ``

export const REVIEWS = `
What Our Clients Say
Our clients are our partners and we help our clients achieve their business goals.

I recently worked with NordNative OÜ on a web development project and was extremely impressed with their work. Their team was knowledgeable, professional, and easy to work with. They took the time to understand our needs and delivered a website that exceeded our expectations. The website was not only visually appealing but also user-friendly and easy to navigate. I would highly recommend NordNative OÜ to anyone looking for high-quality web development services.

Alan Ginsburg
GM Savior Foods
I had the pleasure of working with NordNative OÜ on a software development project and was extremely impressed with their work. Their team was knowledgeable, professional, and easy to work with. They took the time to understand our needs and delivered a software solution that exceeded our expectations. The software was not only functional but also user-friendly and easy to maintain. I would highly recommend NordNative OÜ to anyone looking for high-quality software development services.
Kate Bucher
Learning Online
I recently worked with NordNative OÜ on a software development and digital marketing project and was extremely impressed with their work. Their team was knowledgeable, professional, and easy to work with. They took the time to understand our needs and delivered a software solution that exceeded our expectations. The software was not only functional but also user-friendly and easy to maintain. Their digital marketing team helped us increase our online presence and reach more potential customers through SEO, PPC advertising, social media marketing, email marketing, and content marketing. I would highly recommend NordNative OÜ to anyone looking for high-quality software development and digital marketing services.
Bill Mingo
CarRepair`

export const CUSTOMERS_COUNT = [
  { title: 'SaaS Deployments', counterPostfix: '+', count: 150, current: 15 },
  { title: 'Active Subscriptions', counterPostfix: '+', count: 1200, current: 120 },
  { title: 'Uptime Guarantee', counterPostfix: '%', count: 99.9, current: 99.9 }
];

export const PHOTOS_01 = [
  { url: 'images/home/carousel01/innovation.png', title: 'Innovation' },
  { url: 'images/home/carousel01/quality.jpg', title: 'Quality' },
  { url: 'images/home/carousel01/adaptability.png', title: 'Adaptability' },
  { url: 'images/home/carousel01/focus.png', title: 'Focus' },
  // { url: 'images/home/carousel01/quality.jpg', title: 'Photo 5' },
];


export const TAGS_CLOUD_01 = [
  'Lead Capture', 'Lead Scoring', 'Pipeline Automation', 'Email Workflows', 'Audience Segmentation',
  'Campaign Management', 'Lead Nurturing', 'CRM Sync', 'Attribution Reporting', 'Unified Dashboards'
];
